import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { NgxSpinnerService } from 'ngx-spinner';
import { JwtHelperService } from '@auth0/angular-jwt';
import { finalize } from 'rxjs';
import { ColaboratorLogin } from 'src/app/module/auth/models/user';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly token = 'token';
  authUrl = environment.BaseURL + environment.MicroService.Auth;

  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private storageService: StorageService
  ) {  }

  authUser(userLogin: ColaboratorLogin, eventId: string) {
    this.spinner.show();
    userLogin.eventId = eventId;
    return this.http.post<any>(`${this.authUrl}/login/colab`, userLogin).pipe(
      finalize(() => {
        this.spinner.hide();
      })
    );
  }

  isLogged() {
    return !!this.getToken();
  }

  getUserDetails() {
    const helper = new JwtHelperService();
    const token = this.getToken();

    if (!token) {
      return null;
    }

    try {
      return helper.decodeToken(token);
    } catch (error) {
      console.error('Erro ao decodificar o token do usuário.', error);
      return null;
    }
  }

  getToken() {
    return this.storageService.getItem(this.token);
  }

  removeToken() {
    this.storageService.removeItem(this.token);
  }

  setToken(token: string) {
    this.storageService.setItem(this.token, token);
  }
}
